import { createAction } from 'redux-act';

import IPlaceProfile from '../../../models/interfaces/PlaceProfile';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchProfilePayload extends FetchPayload {
  placeUuid: string;
}
export const fetchProfile = createAction<FetchProfilePayload>('FETCH_PROFILE');

export interface ProfileFetchedPayload extends TimestampPayload {
  profile: IPlaceProfile;
}
export const profileFetched = createAction<ProfileFetchedPayload>('PROFILE_FETCHED');

export interface ProfileFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const profileFetchFailed = createAction<ProfileFetchFailedPayload>('PROFILE_FETCH_FAILED');

export type ProfileFetchResponsePayload = ProfileFetchedPayload | ProfileFetchFailedPayload;
